"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');




var _upgrade = require('shared/enum/upgrade');
var _chat = require('shared/enum/chat');
var _user = require('shared/selectors/user');



var _session = require('shared/selectors/session');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _hooks = require('web/services/hooks');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);
var _hooks3 = require('./hooks');
var _RightSide = require('web/components/RightSide');
var _App = require('web/screens/App');
var _NewChat = require('web/screens/CreateNew/NewChat'); var _NewChat2 = _interopRequireDefault(_NewChat);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _TeamPage = require('./TeamPage'); var _TeamPage2 = _interopRequireDefault(_TeamPage);
var _UserPage = require('./UserPage'); var _UserPage2 = _interopRequireDefault(_UserPage);
var _PatientPage = require('./PatientPage'); var _PatientPage2 = _interopRequireDefault(_PatientPage);
var _EmptyPage = require('./EmptyPage'); var _EmptyPage2 = _interopRequireDefault(_EmptyPage);
var _Sidebar = require('./Sidebar'); var _Sidebar2 = _interopRequireDefault(_Sidebar);
var _PatientTable = require('./PatientTable'); var _PatientTable2 = _interopRequireDefault(_PatientTable);
var _types = require('./types');

const Directory = () => {
  const selectedOrgKey = _hooks.useAppSelector.call(void 0, _session.selectSelectedOrgKey)
  const explicitlySelectedOrgKey = _hooks.useAppSelector.call(void 0, _session.selectExplicitlySelectedOrgKey)
  const myActiveOrgsMap = _hooks.useAppSelector.call(void 0, _user.selectMyActiveOrgsMap)
  const {
    routeOrgKey,
    entityKey,
    routeConversationKey,
    routeChatKey,
    virtualOrgKey,
    selectedTab,
    setSelectedTab,
    isInPage,
  } = _hooks3.useRouting.call(void 0, { myActiveOrgsMap, selectedOrgKey, explicitlySelectedOrgKey })

  // The side panel opens only on a patient's page route, not a coworker's or a team's.
  const patientRoute = _reactrouterdom.useRouteMatch(_routes2.default.DIRECTORY.PATIENT_PAGE)

  const {
    newChatEntitiesList,
    isDraftOpen,
    onCreateNewChat,
    onCloseCreateNewChat,
    onDraftChange,
  } = _hooks3.useEntityChat.call(void 0, )

  const {
    isOpen: isUpsellModalOpen,
    onOpen: onOpenUpsellModal,
    onClose: onCloseUpsellModal,
  } = _useToggle2.default.call(void 0, )

  const upgradeModal = selectedOrgKey && (
    _react2.default.createElement(_UpgradeModal2.default, {
      orgKey: selectedOrgKey,
      type: _upgrade.SubscriptionItemType.SMS,
      isOpen: isUpsellModalOpen,
      onClose: onCloseUpsellModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
    )
  )
  // New chat opens as a draft in the page's place, as the Inbox's chat does;
  // the page stays mounted under it (Directory redesign, #1173).
  const newChatDraft = !!newChatEntitiesList.length && (
    _react2.default.createElement(_NewChat2.default, {
      chatType: _chat.CHAT_TYPE.REGULAR,
      initialEntitiesList: newChatEntitiesList,
      gotoConversation: _actions2.default.gotoBlobject,
      onCloseCreateNewChat: onCloseCreateNewChat,
      onFinished: onCloseCreateNewChat,
      onDraftChange: onDraftChange, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
    )
  )

  // Web and desktop show the Patients tab as the full-width patient table;
  // a patient's page opens as its side panel (D-7, D-18).
  if (selectedTab === _types.DirectoryTab.PATIENTS && virtualOrgKey) {
    return (
      _react2.default.createElement(_App.AppVertical, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
        /* Hidden, not unmounted, under New chat's draft: the table keeps its page and selection. */
        , _react2.default.createElement('div', { style: { display: isDraftOpen ? 'none' : 'contents' }, 'aria-hidden': isDraftOpen || undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
        , _react2.default.createElement(_PatientTable2.default, {
          key: virtualOrgKey,
          orgKey: virtualOrgKey,
          selectedTab: selectedTab,
          onSelectTab: setSelectedTab,
          openPatientKey: patientRoute && patientRoute.params.orgKey === virtualOrgKey
            // SAFETY: the patient page route's last segment is a patient key.
            ? patientRoute.params.patientKey 
            : null,
          onRequestPatientsFeature: onOpenUpsellModal,
          onStartChat: onCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
        )
        )
        ,  upgradeModal 
        ,  newChatDraft 
      )
    )
  }

  return (
    _react2.default.createElement(_App.AppVertical, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
      , _react2.default.createElement(_App.NavigationMenu, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
        , _react2.default.createElement(_Sidebar2.default, {
          orgKey: virtualOrgKey,
          onRequestPatientsFeature: onOpenUpsellModal,
          selectedTab: selectedTab,
          onSelectTab: setSelectedTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
        )
      )
      /* The page stays mounted under New chat's draft, as the Inbox's chat does. */
      , _react2.default.createElement(_RightSide.RightSide, {
        className: _classBuilder2.default.call(void 0, 'directory--right-side', isDraftOpen && 'right-side---hidden'),
        'aria-hidden': isDraftOpen || undefined,
        inView: isInPage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}}

        , _react2.default.createElement(_reactrouterdom.Switch, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
          , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.DIRECTORY.USER_PAGE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
            ,  entityKey && routeOrgKey && (
              _react2.default.createElement(_UserPage2.default, {
                orgKey: routeOrgKey,
                userKey: entityKey ,
                chatKey: routeChatKey,
                onStartChat: onCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
              )
            )
          )
          , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.DIRECTORY.PATIENT_PAGE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
            ,  entityKey && routeOrgKey && (
              _react2.default.createElement(_PatientPage2.default, {
                orgKey: routeOrgKey,
                patientKey: entityKey ,
                onRequestPatientsFeature: onOpenUpsellModal,
                onStartChat: onCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}
              )
            )
          )
          , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.DIRECTORY.TEAM_PAGE, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
            ,  entityKey && routeOrgKey && (
              _react2.default.createElement(_TeamPage2.default, {
                key: entityKey,
                orgKey: routeOrgKey,
                teamKey: entityKey ,
                conversationKey: routeConversationKey,
                onStartChat: onCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
              )
            )
          )
          , _react2.default.createElement(_reactrouterdom.Route, { path: _routes2.default.DIRECTORY.ROOT, component: _EmptyPage2.default, __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}} )
        )
        ,  upgradeModal 
      )
      ,  newChatDraft 
    )
  )
}

exports. default = _react.memo.call(void 0, Directory)
